
const AUTH_REGISTER = 'AUTH_REGISTER'
const AUTH_LOGOUT = 'AUTH_LOGOUT'
const WINDOW_CHANGE = 'WINDOW_CHANGE'

const initState = {
    auth: {},
    isMobile: false
}
export function config(state = initState, action) {
    switch (action.type) {
        case AUTH_REGISTER:
            return { ...state, auth: action.payload }
        case AUTH_LOGOUT:
            return initState
        case WINDOW_CHANGE:
            return { ...state, isMobile: action.payload }
        default:
            return state
    }
}


function ActionAuthRegister(data) {
    return { type: AUTH_REGISTER, payload: data }
}

function ActionLogout() {
    return { type: AUTH_LOGOUT }
}

function ActionChangeWindow(isMobile) {
    return { type: WINDOW_CHANGE, payload: isMobile }
}

export function authRegister(auth) {
    return dispatch => {
        dispatch(ActionAuthRegister(auth))
    }
}

export function logout() {
    return dispatch => {
        dispatch(ActionLogout())
    }
}

export function windowResize(isMobile) {
    return dispatch => {
        dispatch(ActionChangeWindow(isMobile))
    }
}



// WEBPACK FOOTER //
// ./src/reducer/config.redux.js